
// =============================================================================
// models/commerce/Variant.js - PRODUCTION READY
// =============================================================================

import { Model } from 'pinia-orm';

export default class Summary extends Model {
  static entity = 'summaries';
  static primaryKey = 'id';
  static fields() {
    return {
      id: this.uid(),
      orderBoxId: this.attr(''),
      status: this.attr(''),
      totalAmount: this.attr(0),
      totalQty: this.attr(0),
      itemCount: this.attr(0),
      firstCreatedAt:this.attr(''),
      lastUpdatedAt:this.attr(''),

      // Relationship
      // orderBox: this.belongsTo(OrderBox, 'orderBoxId'),
    };
  }

  // ==========================================================================
  // BUSINESS LOGIC
  // ==========================================================================

}
